import { RouteRecordRaw } from 'vue-router';
import { validateIdAsPositiveIntegerGuard } from '@/router/routeGuards';
import NumberPage from '@/views/pages/number/NumberPage.vue';
import NumberDetailPage from '@/views/pages/number/NumberDetailPage.vue';
import NumberFormPage from '@/views/pages/number/NumberFormPage.vue';
import { FormAction } from '@/types';

const numberRouter: RouteRecordRaw = {
    name: 'Number',
    path: 'number',
    children: [
        {
            name: 'ListNumber',
            path: '',
            component: NumberPage,
        },
        {
            name: 'ViewNumberById',
            path: ':id',
            component: NumberDetailPage,
            beforeEnter: [validateIdAsPositiveIntegerGuard],
            meta: { isLevelLocked: true },
        },
        {
            name: 'EditNumberById',
            path: ':id/edit',
            component: NumberFormPage,
            beforeEnter: [validateIdAsPositiveIntegerGuard],
            props: { action: FormAction.EDIT },
            meta: { isLevelLocked: true },
        },
        {
            name: 'CreateNumber',
            path: 'create',
            component: NumberFormPage,
            props: { action: FormAction.CREATE },
            meta: { isLevelLocked: true },
        },
    ],
};

export default numberRouter;
